<template>
    <div>
        <div v-if="screen === 'timeout' || screen === 'pregame'">
            <timeout />
        </div>
        <!-- <div v-else-if="screen === 'pregame'">
            <past-meetings v-if="pregameIndex === 0" @changePregameIndex="changePregameIndex" />
            <match-standings-component v-else-if="pregameIndex === 1" />
            <mvp-comparison v-else-if="pregameIndex === 2" :mvp="false" />
            <team-comparison v-else-if="pregameIndex === 3" />
        </div> -->
        <div v-else-if="screen === 'half-time'">
            <half-time />
        </div>
        <div v-else-if="screen === 'full-time'">
            <half-time v-if="pregameIndex === 0" />
            <!-- <mvp-comparison v-else-if="pregameIndex === 1" :mvp="true" />
            <match-standings-component v-else-if="pregameIndex === 2" /> -->
        </div>
        <div v-show="screen === 'live-score' || screen === 'starters'">
            <div class="score-bottom-left">
                <live-score :id="$route.params.id" @setShowScreen="showScreen" />
            </div>
            <div class="stat-right">
                <live-stat :id="$route.params.id" class="animate" :show-active-players="false" @setShowScreen="showScreen" />
            </div>
        </div>
    </div>
</template>

<script>
    import LiveStat from '@/routes/LiveStat'
    import LiveScore from '@/routes/LiveScore'
    import Timeout from '@/components/Timeout.vue'
    import HalfTime from '@/components/HalfTime.vue'
    // import MvpComparison from '@/components/MvpComparison.vue'
    // import TeamComparison from '@/components/TeamComparison.vue'
    // import PastMeetings from '@/components/PastMeetings.vue'
    // import MatchStandingsComponent from '@/components/MatchStandingsComponent.vue'

    export default {
        components: {
            LiveStat,
            LiveScore,
            Timeout,
            HalfTime
            // MvpComparison,
            // TeamComparison,
            // PastMeetings,
            // MatchStandingsComponent
        },
        data() {
            return {
                screen: 'live-score',
                pregameIndex: 0,
                pregameTimer: null,
                pregameIntervalMs: 20000 // 20 seconds
            }
        },
        watch: {
            screen(newVal) {
                // if (newVal === 'pregame' || newVal === 'full-time') {
                //     this.startPregameRotation()
                // } else {
                //     this.stopPregameRotation()
                // }
            }
        },
        mounted() {
            // if (this.screen === 'pregame' || this.screen === 'full-time') this.startPregameRotation()
        },
        beforeDestroy() {
            // this.stopPregameRotation()
        },
        methods: {
            showScreen(screen) {
                if ((this.screen === 'timeout' || this.screen === 'half-time') && screen === 'timeout') {
                    this.screen = 'live-score'
                } else {
                    this.screen = screen
                }
            },
            changePregameIndex(index) {
                this.pregameIndex = index
            },
            startPregameRotation() {
                this.stopPregameRotation()
                this.pregameIndex = 0
                this.pregameTimer = setInterval(() => {
                    // advance and wrap around 0..3
                    this.pregameIndex = (this.pregameIndex + 1) % 4
                }, this.pregameIntervalMs)
            },
            stopPregameRotation() {
                if (this.pregameTimer) {
                    clearInterval(this.pregameTimer)
                    this.pregameTimer = null
                }
            }
        }
    }
</script>

<style>
.score-bottom-left {
    position: fixed;
    bottom: 10px;
    left: 10px;
    z-index: 1001;
    width: 600px; /* or whatever width you want */

    /* Optional: add background, padding, etc. */
}

.stat-right {
    position: fixed;
    bottom: 10px;
    left: 785px;
    z-index: 1000;
    width: 600px;
}

@keyframes slideInFromLeft {
    0% { transform: translateX(-100%); }
    100% { transform: translateX(0); }
}

/* .animate {
    animation: 1s ease-out 0s 1 slideInFromLeft;
} */
</style>
